import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const scrollToTop = () => {
  setTimeout(() => {
    window.scrollTo({ top: 800, behavior: "smooth" });
  }, 100); // wait for route change
};

const scrollToTop1 = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const Footer = () => (
  <footer className="footer">
    <div className="footer__links">
      <Link className="footer__links" to="/About" onClick={scrollToTop1}>
        About Us
      </Link>
      <Link className="footer__links" to="/" onClick={scrollToTop}>
        Categories
      </Link>
      <Link className="footer__links" to="/ContactUs" onClick={scrollToTop1}>
        Contact Us
      </Link>
    </div>
    <div className="footer__social">
      {/* Social icons can be added here */}
    </div>
    <div className="footer__copyright">
      &copy; {new Date().getFullYear()} Liv Minus. All rights reserved.
    </div>
  </footer>
);

export default Footer;
